<template>
    <div>
        <input
            type="hidden"
            name="offers_rot_deduction"
            value="0"
        >
        <checkbox-input
            v-model="offers_rot_deduction"
            :value="transformBoolean(offers_rot_deduction)"
            name="offers_rot_deduction"
        >
            Erbjuder ROT
        </checkbox-input>

        <div v-show="offers_rot_deduction" class="my-md">
            <text-input
                v-model="rot_sum"
                :required="offers_rot_deduction"
                :value="rot_sum"
                :error="errorRotSum"
                type="number"
                name="rot_sum"
                label="Summa ROT (kr)"
            />
        </div>

        <div class="my-md">
            <input
                type="hidden"
                name="offers_rut_deduction"
                value="0"
            >
            <checkbox-input
                v-model="offers_rut_deduction"
                :value="transformBoolean(offers_rut_deduction)"
                name="offers_rut_deduction"
            >
                Erbjuder RUT
            </checkbox-input>
        </div>

        <div v-show="offers_rut_deduction">
            <text-input
                v-model="rut_sum"
                :required="offers_rut_deduction"
                :value="rut_sum"
                :error="errorRutSum"
                type="number"
                name="rut_sum"
                label="Summa RUT (kr)"
            />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            offersRotDeduction: {
                type: Boolean,
                required: true,
            },
            offersRutDeduction: {
                type: Boolean,
                required: true,
            },
            rotSum: {
                type: String,
                default: null,
            },
            rutSum: {
                type: String,
                default: null,
            },
            errorRotSum: {
                type: String,
                default: null,
            },
            errorRutSum: {
                type: String,
                default: null,
            },
        },

        data() {
            return {
                offers_rot_deduction: false,
                offers_rut_deduction: false,
                rot_sum: '',
                rut_sum: '',
            };
        },

        watch: {
            offers_rot_deduction(offersRotDeduction) {
                if (! offersRotDeduction) {
                    this.rot_sum = '';
                }
            },
            offers_rut_deduction(offersRutDeduction) {
                if (! offersRutDeduction) {
                    this.rut_sum = '';
                }
            },
        },

        created() {
            this.offers_rot_deduction = this.offersRotDeduction;
            this.offers_rut_deduction = this.offersRutDeduction;
            this.rot_sum = this.rotSum;
            this.rut_sum = this.rutSum;
        },

        methods: {
            transformBoolean(value) {
                // Prevent posting checkbox values as boolean strings
                return value === true ? 1 : 0;
            },
        },
    };
</script>